// One place that turns whatever got typed into a member's social fields into a working link.
// Handles: bare handles, @handles, full URLs, scheme-less URLs, and junk like "N/A".
const JUNK = new Set(["n/a", "na", "none", "-", "no", "tbc", "x", "nil", "null"]);

export const cleanSocial = (v) => {
  const s = (v || "").trim();
  return !s || JUNK.has(s.toLowerCase()) ? "" : s;
};

const bareHandle = (s) => s.replace(/^@/, "").replace(/\/+$/, "");

const social = (v, domain, build) => {
  const s = cleanSocial(v);
  if (!s) return null;
  if (/^https?:/i.test(s)) return s;
  if (s.toLowerCase().includes(domain)) return `https://${s.replace(/^\/+/, "")}`;
  return build(bareHandle(s));
};

export const igUrl = (v) => social(v, "instagram.com", (h) => `https://www.instagram.com/${h}`);
export const ttUrl = (v) => social(v, "tiktok.com", (h) => `https://www.tiktok.com/@${h}`);
export const liUrl = (v) => social(v, "linkedin.com", (h) => `https://www.linkedin.com/in/${h}`);
export const fbUrl = (v) => {
  const s = cleanSocial(v);
  if (!s || (!/^https?:/i.test(s) && s.includes(" "))) return null;
  return social(s, "facebook.com", (h) => `https://www.facebook.com/${h}`);
};
export const webUrl = (v) => {
  const s = cleanSocial(v);
  return s ? (/^https?:/i.test(s) ? s : `https://${s}`) : null;
};
